import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ResourceEditModalComponent} from '../resource-edit-modal/resource-edit-modal.component';
import {ControlContainer, NgForm} from '@angular/forms';
import {SelectComponent} from 'web-shared';
import {takeUntil} from "rxjs/operators";
import {ResourceQuery} from "../models/resource.query";

@Component({
  selector: 'mes-web-resource-select',
  templateUrl: './resource-select.component.html',
  styles: [`
    :host {
      display: flex;
      width: 100%;
      height: 100%;
    }`
  ],
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ResourceSelectComponent extends SelectComponent<ResourceQuery> implements OnInit {
  @Input() userSpecifiedResourceIds: string[] = [];
  @Output() change: EventEmitter<ResourceQuery> = new EventEmitter<ResourceQuery>();
  @Output() userSpecifiedChanged: EventEmitter<ResourceQuery> = new EventEmitter<ResourceQuery>();

  constructor() {
    super();
  }

  ngOnInit() {
    this.refreshToken$.next(undefined);
  }

  addNew(searchTerm: string = null) {
    this.modalService.show(ResourceEditModalComponent, {initialState: {entityName: searchTerm} as ResourceEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
      const comp = bsModalRef.content;
      if (!comp.action && comp.actionType != 'added') {
        return;
      }

      if (this.multiple) {
        this.entityIds = [...this.entityIds, comp.entityId];
        this.entityIdsChange.emit(this.entityIds);
      } else {
        this.setEntityId(comp.entityId);
      }
      this.refreshToken$.next(undefined);
    });
  }

  editExisting(resource: ResourceQuery = null) {
    const id = resource ? resource.Id : this.multiple ? this.entityIds[0] : this.entityId;
    this.modalService.show(ResourceEditModalComponent, {initialState: {entityId: id} as ResourceEditModalComponent, class: 'modal-xl'}).onHide$.pipe(takeUntil(this.componentDestroyed)).subscribe((bsModalRef) => {
      const comp = bsModalRef.content as ResourceEditModalComponent;
      if (!comp.action) {
        return;
      }
      if (this.multiple) {
        if (comp.actionType == 'deleted') {
          this.entityIds = [...this.entityIds.filter(entityId => entityId !== id)];
        }
        this.entityIds = this.entityIds.map(id => id);
        this.entityIdsChange.emit(this.entityIds);
      } else {
        this.setEntityId(comp.entityId);
      }
      this.refreshToken$.next(undefined);
    });
  }

  onSelectionChanged($event: ResourceQuery[] | ResourceQuery) {
    if (this.multiple) {
      const resources = $event as ResourceQuery[];
      if (resources && resources.length) {
        this.entityIdsChange.emit(resources.map(value => value.Id));
      } else {
        this.entityIdsChange.emit([]);
      }
    } else {
      this.setEntityId(($event as ResourceQuery)?.Id);
    }
  }
}
